<template>
  <div class="home">
    <b-container fluid>
      <h1 class="mb-3">Birth Record Data Report</h1>
      <b-row>
        <b-col>
          <router-link to="data-select">
            <b-button>
              <b-icon-box-arrow-in-left/>Return to Product Selection
            </b-button>
          </router-link>
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col cols="12" md="6" lg="3">
          <BaseSelector v-model="details.year"
                        :v="$v.details.year"
                        label="Select year"
                        setId="selectYear"
                        :options = yearOptions
          />
        </b-col>
        <b-col cols="12" md="6" lg="2">
          <BaseTextInput v-model="details.quantity"
                         label="Quantity to order"
                         slug="quantity"
                         setId="quantity"
                         :v="$v.details.quantity"
                         type="number"
                         :min="1" :max="1"
                         tip="Limit 1 copy"
          ></BaseTextInput>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col cols="12" md="6" lg="2">
          <b-button type="button" variant="primary" @click="submit()">Add to Cart</b-button>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>

import BaseSelector from "@/components/templates/input/BaseSelector.vue";
import {yearService} from "@/mixins/yearService";
import {toastService} from "@/mixins/toastService";
import axios from "axios";
import axiosRetry from 'axios-retry'
import LocalStorageService from "@/common/LocalStorageService";
import {required, minValue, maxValue} from 'vuelidate/lib/validators'
import BaseTextInput from "@/components/templates/input/BaseTextInput.vue";
import {orderTypeService} from "@/mixins/orderTypeService";

axiosRetry(axios, { retries: 3,
  retryDelay: axiosRetry.exponentialDelay })
const localStorageService = LocalStorageService.getService()

export default {
  components: {
    BaseTextInput,
    BaseSelector,
  },
  mixins: [
    yearService,
    toastService
  ],

  data: () => ({
    details: {
      orderId: null,
      product: null,
      year: null,
      quantity: 1,
    },
    dataFileOptions: [],
    yearOptions: [],
    currentYear: new Date().getFullYear(),
    productInfo: "Birth record data report: Public data from Minnesota birth records for a specified calendar year. Available from 2011 to the present. The report will provide a preliminary dataset when a statistical dataset is unavailable.",
  }),

  computed: {
    yearSelected(){
      return this.details.year
    }
  },
  watch: {
    yearSelected() {
      if (this.details.year === this.currentYear) {
        toastService.showRootToast("Warning", this.productInfo, "warning", this.$root)
      }
    }
  },
  mounted() {
    document.getElementById('main-content').scrollIntoView();
    this.loadDataProducts()
    this.yearOptions = yearService.generateYears(2011);
  },
  methods: {
    submit() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
      if (!orderTypeService.isTypeSet()) {
        localStorageService.setOrderType('N')
      } else if (orderTypeService.isAmendType()) {
        toastService.showRootToast("Error", "You cannot order a non-amendment product with an amendment order.  You must place a separate order for this item." , "danger", this.$root)
        return
      }
      if (localStorageService.getOrderNumber() != null) {
        this.details.orderId = localStorageService.getOrderNumber()
      }

      axios.post(`${process.env.VUE_APP_API_BASE_URL}/order`, this.details)
          .then(response=>{
            localStorageService.setCartItems(Number(localStorageService.getCartItems()) + 1)
            this.$emit('cart-update')
            localStorageService.setOrderNumber(response.data)
            this.$emit('update-order')
            toastService.showRootToast("Order Updated", "Product has been added to your order" , "success", this.$root)
            this.$router.push({ path: '/cart'})
          })
          .catch(err => {
            if (err?.response?.status === 409) {
              toastService.showRootToast("Error", "You cannot order a non-amendment product with an amendment order.  You must place a separate order for this item." , "danger", this.$root)
            } else {
              toastService.showRootToast("Error", "An error has occurred " , "danger", this.$root)
            }
          })
    },
    loadDataProducts() {
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/options/product/DATA`)
          .then(response=>{
            this.dataFileOptions = response.data
            this.details.product = response.data[0]
          })
    }
  },
  validations() {
    return {
      details: {
        product: { required },
        year: { required },
        quantity: { required, minValue: minValue(1), maxValue: maxValue(1) },
      }
    }
  },
  created() {
    document.title = "Select a Birth Record Data Report - OVR Storefront"
  },

}
</script>
